import React from 'react';
import { Row, Col, Typography, Image } from 'antd';
import { InstagramOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title } = Typography;

const InstagramStoriesAndServices = () => {
    const stories = [
        { src: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png", alt: "Model in white suit", instagramURL: "" },
        { src: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png", alt: "Woman in red sweater", instagramURL: "" },
        { src: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png", alt: "Woman with sunglasses", instagramURL: "" },
        { src: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png", alt: "Man in brown jacket", instagramURL: "" },
    ];

    return (
        <section className='bg-white py-5'>
            <div className="container">
                <Title level={2} className="text-center mb-4 pb-5">Our Instagram Stories</Title>
                <Row gutter={[16, 16]} className="mb-5">
                    {stories.map((story, index) => (
                        <Col xs={12} sm={6} key={index}>
                            <div className="position-relative overflow-hidden rounded image-wrapper">
                                <Image src={story.src} alt={story.alt} className="w-100" preview={false}
                                />
                                <div className="overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center transition-opacity duration-300">
                                    <Link target='_blank' to={`${story.instagramURL}`}><InstagramOutlined className="text-white" style={{ fontSize: '2rem' }} /></Link>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </section>
    );
};

export default InstagramStoriesAndServices;